import React from "react";
import styles from "./Contact.module.css";
import PageLayout from "../../components/PageLayout/PageLayout";

import {
  FiPhone,
  FiMail,
  FiMapPin,
  FiClock,
  FiHome,
} from "react-icons/fi";

const Contact: React.FC = () => {
  return (
    <PageLayout className={styles.Contact}>
      <div className={styles.hero}>
        <div>
          <h1 className={styles.title}>Kontakt</h1>

          <p className={styles.lead}>
            Skontaktuj się z nami — odpowiemy najszybciej jak to możliwe.
          </p>
        </div>

        <div className={styles.quickActions}>
          <a className={styles.actionBtn} href="tel:+48796327266">
            <FiPhone className={styles.icon} />
            Zadzwoń
          </a>

          <a
            className={styles.actionBtn}
            href="mailto:kontakt@cartena.com.pl"
          >
            <FiMail className={styles.icon} />
            Napisz e-mail
          </a>
        </div>
      </div>

      <div className={styles.grid}>
        <article className={styles.card}>
          <div className={styles.cardHeader}>
            <FiHome className={styles.cardIcon} />
            <h2 className={styles.cardTitle}>Dane firmy</h2>
          </div>

          <div className={styles.lines}>
            <div className={styles.lineStrong}>CARTENA</div>

            <div className={styles.line}>
              Telefon:
              <a className={styles.link} href="tel:+48796327266">
                796 327 266
              </a>
            </div>

            <div className={styles.line}>
              E-mail:
              <a
                className={styles.link}
                href="mailto:kontakt@cartena.com.pl"
              >
                kontakt@cartena.com.pl
              </a>
            </div>

            <div className={styles.divider} />

            <div className={styles.line}>
              NIP: <span className={styles.mono}>5833108652</span>
            </div>
          </div>
        </article>

        <article className={styles.card}>
          <div className={styles.cardHeader}>
            <FiMapPin className={styles.cardIcon} />
            <h2 className={styles.cardTitle}>Adres</h2>
          </div>

          <address className={styles.address}>
            <div className={styles.line}>ul. Ptasia 18</div>
            <div className={styles.line}>80-035 Gdańsk</div>

            <a
              className={styles.mapButton}
              href="https://www.google.com/maps/search/?api=1&query=ul.+Ptasia+18+80-035+Gdańsk"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FiMapPin className={styles.icon} />
              Otwórz w Google Maps
            </a>
          </address>
        </article>

        <article className={`${styles.card} ${styles.cardWide}`}>
          <div className={styles.cardHeader}>
            <FiClock className={styles.cardIcon} />
            <h2 className={styles.cardTitle}>Godziny kontaktu</h2>
          </div>

          <div className={styles.hours}>
            <div className={styles.hourRow}>
              <span>Pon–Pt</span>
              <span className={styles.badge}>08:00 – 20:00</span>
            </div>

            <div className={styles.hourRow}>
              <span>Sobota</span>
              <span className={styles.badge}>09:00 – 14:00</span>
            </div>

            <div className={styles.hourRow}>
              <span>Niedziela</span>
              <span className={styles.badgeMuted}>zamknięte</span>
            </div>
          </div>
        </article>
      </div>
    </PageLayout>
  );
};

export default Contact;